import { TABLES } from '@/utils/constants';
import { getRecord } from '@/utils/helpers/data';
import { SHARE_COLUMNS, Share } from '@/utils/schema';

export type { Share };
export const COLUMNS = SHARE_COLUMNS;

/**
 * Retrieves the clinic ID associated with a specific share code.
 * @param code - The code of the share.
 * @returns The clinic ID or null if not found.
 */
export const getClinicIdByShareCode = async (
  code: string
): Promise<string | null> => {
  const share = await getRecord<Pick<Share, 'clinic_id'>>(
    TABLES.SHARES,
    COLUMNS.CODE,
    code.toLowerCase()
  );
  return share?.clinic_id ?? null;
};
